import React, { useCallback, useState } from "react";
import { withRouter } from "react-router";
import WithAjax from "../common/helpers/WithAjax";

const ArticleDeleteButton = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onDelete = useCallback(
    () => {
      setIsLoading(true);
      props.ajax
        .deletePromise(`articles/${props.articleId}`)
        .then(() => {
          props.history.push("/news");
        })
        .catch(() => setErrorMessage("Could not delete this article, please try again later."))
        .finally(() => setIsLoading(false));
    },
    [props.articleId]
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start", maxWidth: "100px" }}>
      <button className="btn btn-danger btn-rounded" onClick={() => onDelete()}>
        {!isLoading && <span>Delete</span>}
        {isLoading && <div>Loading...</div>}
      </button>
      {<p style={{ fontSize: "10px", color: "red", marginTop: "5px" }}>{errorMessage}</p>}
    </div>
  );
};

export default withRouter(WithAjax(ArticleDeleteButton));
